<template>
  <div id="user-departments-list" class="user-departments-list-container">

    <user-departments-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :userDepartment="sidebarData"
    />

    <user-departments-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="userDepartments"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            v-if="canSee('add')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="addNewData"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    userDepartments.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : userDepartments.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="email">Nome</vs-th>
        <vs-th sort-key="name">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-email font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getDepartmentStatusColor(tr.activated)" class="product-order-status">
                {{ getDepartmentStatusName(tr.activated) | title }}
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2 mr-2"
                v-if="canSee('update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />

              <feather-icon
                v-if="canSee('delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="openConfirmationPopup(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
        <vs-popup  title="Você tem certeza que deseja continuar?" :active.sync="confirmationPopup" class="sizePopup">
          <p class="mb-5">Você deseja realmente deletar o departamento <strong>{{ selectedDepartment ? selectedDepartment.name : '' }}</strong>?</p>

          <hr/>

          <vs-row
            vs-align="flex-end"
            vs-type="flex"
            vs-justify="flex-end"
            vs-w="12"
            class="mt-5"
          >
            <vs-button color="dark" type="flat" class="mr-3" @click.stop="confirmationPopup = false">
              Cancelar
            </vs-button>

            <vs-button color="danger" type="filled" @click.stop="executeDelete">
              Continuar
            </vs-button>
          </vs-row>
        </vs-popup>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import UserDepartmentsViewSidebar from './UserDepartmentsViewSidebar'

  import moduleUserDepartment from '@/store/userDepartment/moduleUserDepartment'
  import { hasPermission } from '@/utils'

  export default {
    name: 'user-departments-list',
    components: {
      UserDepartmentsViewSidebar
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        confirmationPopup: false,
        selectedDepartment: null,
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }

        return 0
      },
      userDepartments() {
        return this.$store.state.userDepartment.userDepartments
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.userDepartments.length
      }
    },
    methods: {
      openConfirmationPopup(department) {
        this.selectedDepartment = department;
        this.confirmationPopup = true;
      },
      getDepartmentStatusName(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'Ativo'
        }

        return 'Desativado'
      },
      getDepartmentStatusColor(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'success'
        }

        return 'danger'
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData(userDepartmentId) {
        this.$store.dispatch("userDepartment/delete", userDepartmentId)
        .then(res => {
          this.$vs.notify({
          color:'success',
          title:'Atenção',
          text:'Departamento deletado com Sucesso'
          })
        }) 
        .catch(err => { console.error(err) })
      },
      editData(data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
      },
      executeDelete(){
        if (this.selectedDepartment) {
        this.deleteData(this.selectedDepartment.id);
        this.selectedDepartment = null;
        this.confirmationPopup = false;
    }
      }
    },
    created() {
      if (!moduleUserDepartment.isRegistered) {
        this.$store.registerModule('userDepartment', moduleUserDepartment)
        moduleUserDepartment.isRegistered = true
      }
      this.$store.dispatch("userDepartment/fetch")
    },
    beforeRouteLeave(to, from, next) {
      if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 1);
      }else if(this.confirmationPopup){
        this.confirmationPopup = false
        setTimeout( ()=> {
          next();
        }, 1);
      }
      else {
        next();
      }
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #user-departments-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
